module.exports = __webpack_public_path__ + "images/landing/video-previews/be_brilliant_video_preview_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/be_brilliant_video_preview_2x.jpg
// module id = 4c32
// module chunks = 1